import { Button, Form } from "@sellar-io/components";
import { useEffect, useState } from "react";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import { FulfillmentTypeRadioGroup } from "../groups/FulfillmentTypeRadioGroup";
import { CheckoutSelectedFulfillmentType } from "../../../stockList";

export const FulfillmentTypeDialog = ({
  active,
  onDismiss,
  fulfillmentType,
  onSubmit,
  postcode,
  distributionDeliveryEstimate,
  distributionOrderBy,
}: {
  active: boolean;
  onDismiss: () => void;
  fulfillmentType: CheckoutSelectedFulfillmentType;
  onSubmit: (fulfillmentType: CheckoutSelectedFulfillmentType) => void;
  postcode?: string;
  distributionDeliveryEstimate?: string;
  distributionOrderBy?: string;
}) => {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => onDismiss()}
        title={"Edit fulfillment type"}
      />
      <DialogContent className={"flex flex-col gap-4 p-4"}>
        <Alert
          className={"w-full"}
          type={"information"}
          title={"Updating fulfillment type"}
          message={
            "Any delivery charges that have been applied automatically will be recalculated."
          }
        />
        <FulfillmentTypeForm
          fulfillmentType={fulfillmentType}
          onSubmit={onSubmit}
          distributionDeliveryEstimate={distributionDeliveryEstimate}
          distributionOrderBy={distributionOrderBy}
          postcode={postcode}
        />
      </DialogContent>
    </Dialog>
  );
};

export const FulfillmentTypeForm = ({
  fulfillmentType: initFulfillmentType,
  onSubmit,
  postcode,
  distributionDeliveryEstimate,
  distributionOrderBy,
}: {
  fulfillmentType: CheckoutSelectedFulfillmentType;
  onSubmit: (fulfillmentType: CheckoutSelectedFulfillmentType) => void;
  postcode?: string;
  distributionDeliveryEstimate?: string;
  distributionOrderBy?: string;
}) => {
  const [fulfillmentType, setFulfillmentType] = useState(initFulfillmentType);

  useEffect(() => {
    return () => {
      setFulfillmentType(initFulfillmentType);
    };
  }, [initFulfillmentType]);

  return (
    <Form
      className={"flex flex-col gap-6"}
      onSubmit={() => onSubmit(fulfillmentType)}
    >
      <FulfillmentTypeRadioGroup
        fulfillmentType={fulfillmentType}
        onChange={(fulfillmentType) => setFulfillmentType(fulfillmentType)}
        distributionDeliveryEstimate={distributionDeliveryEstimate}
        distributionOrderBy={distributionOrderBy}
        postcode={postcode}
      />
      <Button
        className={"w-full"}
        disabled={initFulfillmentType === fulfillmentType}
        type={"submit"}
      >
        Update
      </Button>
    </Form>
  );
};
